import { render, staticRenderFns } from "./AddReservedSlotForm.vue?vue&type=template&id=c32ea220"
import script from "./AddReservedSlotForm.vue?vue&type=script&lang=ts"
export * from "./AddReservedSlotForm.vue?vue&type=script&lang=ts"
import style0 from "./AddReservedSlotForm.vue?vue&type=style&index=0&id=c32ea220&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports